import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetDressCodePicturesErrorAction implements Action {
  public static readonly type = 'GetDressCodePicturesErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetDressCodePicturesErrorAction.type;
}
